<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a @click="openPage('/memberDiary/activity/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(actions)="data">
<!--          <template slot="actions" slot-scope="data">-->
            <b-button size="sm" @click="editForm('/memberDiary/activity/edit/' + data.item.id)" class="btn-table warning mr-1">
            <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button size="sm" v-on:click="deleteForm(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'memberDiary',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'excercise_name',
          label: 'Name',
          sortable: true
        },
        // {
        //   key: 'sets',
        //   label: 'Sets',
        //   sortable: true
        // },
        // {
        //   key: 'reps',
        //   label: 'Reps',
        //   sortable: true
        // },
        // {
        //   key: 'time',
        //   label: 'time',
        //   sortable: true
        // },
        // {
        //   key: 'rest_time',
        //   label: 'Rest Time',
        //   sortable: true
        // },
        // {
        //   key: 'weight',
        //   label: 'Weight',
        //   sortable: true
        // },
        // {
        //   key: 'intensity',
        //   label: 'Intensity',
        //   sortable: true
        // },
        {
          key: 'member_pt_diary_subcategory.name',
          label: 'Sub Category',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: true
        }
      ],
      items: [],
      getId: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    async pageOneChanged (pageNum) {
      this.currentPage = pageNum
      await this.fetchData()
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.fetchData()
    },
    async enterClicked (searchEvent) {
      await this.fetchData()
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    async deleteForm(event) {
      let isOk = await this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      })

      if (!isOk.value) {
        this.$swal('Cancelled', 'Your file is still intact', 'info')
        return
      }

      try {
        axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
        await axios.delete('crm/v1/member_pt_diary_activity/'.concat(event))
        this.$swal('Deleted', 'You successfully deleted this file', 'success')
        this.fetchData()
      } catch (error) {
        console.log('error', error)
      }
    },
    async fetchData() {
        try {
            axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            let response = await axios.get('crm/v1/member_pt_diary_activity?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData)
            this.items = response.data.data.rows
            this.totalPage = response.data.meta.pageCount
        } catch (error) {
            console.log(error)
        }
    }
  },
  async created () {
    await this.fetchData()
  }
}
</script>

<style>
</style>
